<template>
  <div :class="['na-metric-card', { 'na-metric-selected': selected }]" :style="!selected && gradient ? { background: gradient + ', #fff' } : {}" @click="$emit('select', metricKey)">
    <div class="na-metric-header">
      <img v-if="iconSrc" :src="iconSrc" :alt="label" :class="['na-metric-icon', { 'na-metric-icon-dark': darkIcon }]" />
      <font-awesome-icon v-else-if="faIcon" :icon="faIcon" class="na-metric-fa-icon" />
      <span class="na-metric-label" v-html="labelHtml"></span>
    </div>

    <div class="na-metric-body">
      <div class="na-metric-value" v-if="inlineUnit">{{ formattedValue }}{{ unit }}</div>
      <template v-else>
        <div class="na-metric-value">{{ formattedValue }}</div>
        <div class="na-metric-unit" v-if="unit">{{ unit }}</div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "NewAsideMetricCard",
  props: {
    label: { type: String, required: true },
    value: { type: [String, Number], default: "N/D" },
    unit: { type: String, default: "" },
    iconSrc: { type: String, default: null },
    faIcon: { type: String, default: null },
    colorBar: { type: Boolean, default: false },
    metricKey: { type: String, default: "" },
    gradient: { type: String, default: null },
    selected: { type: Boolean, default: false },
    inlineUnit: { type: Boolean, default: false },
    darkIcon: { type: Boolean, default: false },
  },
  emits: ["select"],
  computed: {
    formattedValue() {
      if (this.value == null || this.value === "") return "N/D";
      if (typeof this.value === "number") {
        return Number.isInteger(this.value) ? this.value : this.value.toFixed(2);
      }
      return this.value;
    },
    labelHtml() {
      return this.label.replace(/\n/g, '<br/>');
    },
  },
};
</script>

<style scoped>
.na-metric-card {
  background: #fff;
  border-radius: 10px;
  padding: 10px;
  cursor: pointer;
  transition: box-shadow 0.2s;
  display: flex;
  flex-direction: column;
  min-height: 90px;
}

.na-metric-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.na-metric-selected {
  background: #EFF3FF !important;
  border: 1px solid #BBD1FF;
}

.na-metric-header {
  display: flex;
  align-items: center;
  gap: 6px;
}

.na-metric-icon {
  width: 22px;
  height: 22px;
  object-fit: contain;
  flex-shrink: 0;
  filter: brightness(0);
}

.na-metric-fa-icon {
  font-size: 16px;
  color: #333;
  flex-shrink: 0;
}

.na-metric-label {
  font-size: 12px;
  color: #333;
  font-weight: 400;
  line-height: 1.2;
}

.na-metric-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.na-metric-value {
  font-size: 18px;
  font-weight: 700;
  color: #333;
  line-height: 1.2;
  text-align: center;
}

.na-metric-unit {
  font-size: 13px;
  color: #666;
  text-align: center;
}
</style>
